<template>
  <div>
    <div class="ui-g" v-bind:class="{ hide: $router.currentRoute.path != '/' }">
      <div class="ui-g-6" id="top">
        <img src="static/hmg-logos/HMG-logo_red@2x.png" class="hmg-logo">
      </div>

      <div class="ui-g-6 menu-cont">
        <a href="#" v-scroll-to="'#agencyProfile'" class="sm-hide">Agency Profile</a>
        <a href="#" v-scroll-to="'#agencyProfile'" class="lg-hide xl-hide md-hide">Profile</a>
        <a href="#" v-scroll-to="'#contact'" class="adjusted-margins">Contact</a>
      </div>

      <div class="ui-g-12 header-cont">
        <p class="black">We drive business performance by creating unique brand experiences that consumers love.</p>
      </div>

      <div class="ui-g-12 project-row">
        <div class="ui-g">
          <!-- Desktop: Mazda Clubhouse Privileges -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('mazda-canada-clubhouse-privileges')"
          >
            <div>
              <img
                src="static/images/mazda-canada-clubhouse-privileges/mazda-canada_clubhouse-privileges_desktop-render@1.5x.jpg"
              >
              <span class="fade ui-g-center"></span>
              <div class="words">
                <h3>Mazda Canada</h3>
                <p>Mazda Clubhouse Privileges</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Mazda Clubhouse Privileges -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('mazda-canada-clubhouse-privileges')"
          >
            <div class="mazdaClubhousePrivileges"></div>
          </section>

          <!-- Desktop: 2019 Nissa Altima -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('nissan-usa-2019-altima')"
          >
            <div>
              <img
                src="static/images/nissan-usa-2019-altima/nissan-usa_2019-altima_homepage_desktop-render@1.5x.jpg"
              >
              <span class="fade ui-g-center"></span>
              <div class="words">
                <h3>Nissan USA</h3>
                <p>2019 Nissan Altima Launch</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: 2019 Nissa Altima -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('nissan-usa-2019-altima')"
          >
            <div class="nissanUSA2019"></div>
          </section>

          <!-- Desktop: QX50 -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('infiniti-usa-2019-QX50')"
          >
            <div>
              <img src="static/images/qx50/qx50_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>2019 QX50 Launch</p> -->
              </span>
              <div class="words">
                <h3>Infiniti USA</h3>
                <p>2019 QX50 Launch</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: QX50 -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('infiniti-usa-2019-QX50')"
          >
            <div class="qx50"></div>
          </section>

          <!-- Desktop: Nissan -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('nissan-usa-2018-leaf')"
          >
            <div>
              <img src="static/images/nissan/nissan_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>2018 Nissan LEAF Launch</p> -->
              </span>
              <div class="words">
                <h3>Nissan USA</h3>
                <p>2018 Nissan LEAF Launch</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Nissan -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('nissan-usa-2018-leaf')"
          >
            <div class="nissan"></div>
          </section>

          <!-- Desktop: Mazda Winter -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('mazda-canada-winter-sales-event')"
          >
            <div>
              <img src="static/images/mazda-winter/mazda_winter_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>Winter Sales Event with Bose</p> -->
              </span>
              <div class="words">
                <h3>Mazda Canada</h3>
                <p>Winter Sales Event with Bose&reg;</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Mazda Winter -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('mazda-canada-winter-sales-event')"
          >
            <div class="mazda-winter"></div>
          </section>

          <!-- Desktop: Trender -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('tender-birmingham')"
          >
            <div>
              <img src="static/images/trender/tender_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>Ongoing Fashion Campaign</p> -->
              </span>
              <div class="words">
                <h3>Tender Birmingham</h3>
                <p>Ongoing Fashion Campaign</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Trender -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('tender-birmingham')"
          >
            <div class="trender"></div>
          </section>

          <!-- Desktop: Mazda Summer -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('mazda-canada-summer-sales-event')"
          >
            <div>
              <img src="static/images/mazda-summer/mazda_summer_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>National Summer Sales Event</p> -->
              </span>
              <div class="words">
                <h3>Mazda Canada</h3>
                <p>National Summer Sales Event</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Mazda Summer -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('mazda-canada-summer-sales-event')"
          >
            <div class="mazda-summer"></div>
          </section>

          <!-- Desktop: Ally Bank -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('ally-bank-surprise-and-delight')"
          >
            <div>
              <img src="static/images/ally/ally_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>Surprise &amp; Delight Campaign</p> -->
              </span>
              <div class="words">
                <h3>Ally Bank</h3>
                <p>Surprise &amp; Delight Campaign</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Ally Bank -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('ally-bank-surprise-and-delight')"
          >
            <div class="ally"></div>
          </section>

          <!-- Desktop: Blue Cross -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('blue-cross-healthy-blue-xtras')"
          >
            <div>
              <img src="static/images/bcbs/bcbs_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>Healthy Blue Xtras</p> -->
              </span>
              <div class="words">
                <h3>Blue Cross</h3>
                <p>Healthy Blue Xtras</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Blue Cross -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('blue-cross-healthy-blue-xtras')"
          >
            <div class="bcbs"></div>
          </section>

          <!-- Desktop: Exclusiviti -->
          <section
            class="ui-g-6 md-hide sm-hide pointer project-cont"
            @click="loadRoute('infiniti-usa-exclusiviti')"
          >
            <div>
              <img src="static/images/exclusiviti/infiniti_desktop@1.5x.jpg">
              <span class="fade ui-g-center">
                <!-- <p>INFINITI Exclusiviti</p> -->
              </span>
              <div class="words">
                <h3>Infiniti USA</h3>
                <p>INFINITI Exclusiviti</p>
              </div>
            </div>
          </section>

          <!-- Tablet and Mobile: Exclusiviti -->
          <section
            class="ui-md-12 ui-sm-12 lg-hide pointer project-cont"
            @click="loadRoute('infiniti-usa-exclusiviti')"
          >
            <div class="exclusiviti"></div>
          </section>
        </div>
      </div>

      <div class="body-container">

        <div class="ui-g-3 ui-md-12 ui-sm-12 about-us-cont adjusted-margins" id="agencyProfile">
          <h2 class="title">Who We Are</h2>
        </div>

        <div class="ui-g-9 ui-md-12 ui-sm-12 about-us-cont adjusted-margins">
          <p>
            Harris Marketing Group (HMG) is a digitally led agency that’s built to support clients 
            end-to-end. From strategy to execution, we create digital experiences and platforms that 
            engage millions of consumers across all touchpoints.
          </p>
          <p>
            With a proven ability to drive brand growth for clients across a wide variety of 
            categories, HMG has become a recognized leader in creating and managing custom acquisition, 
            conversion, retention, and loyalty strategies.
          </p>
        </div>

        <hr>

        <div class="ui-g-3 ui-md-12 ui-sm-12 about-us-cont adjusted-margins" id="agencyProfile">
          <h2 class="title">What We Do</h2>
        </div>

        <div class="ui-g-9 ui-md-12 ui-sm-12 about-us-cont adjusted-margins">
          <p>
            We help leading brands produce best-in-class experiences for the modern consumer. 
            Connecting data, strategy, content, and technology, we create highly personalized and 
            compelling customer experiences that consistently deliver business results.
          </p>
      
          <p class="sub-heading">Data &amp; Insights</p>
          <p>
            Our Decision Sciences team creates consumer profiles that combine personal and behavioral 
            data to identify, engage, and energize the right consumers &mdash; driving the right outcomes.
          </p>

          <p class="sub-heading">Journey Mapping &amp; Strategy</p>
          <p>
            We create and manage brand-building strategies that palpably enhance customer experiences 
            across the entire lifecycle &mdash; strengthening any desired phase(s) of a brand’s consumer journey.
          </p>

          <p class="sub-heading">Dynamic Content &amp; Experiences</p>
          <p>
            We accelerate the path to purchase by producing bespoke, dynamic content and interactive 
            virtual experiences that, in tandem, work to generate desired consumer actions.
          </p>

          <p class="sub-heading">Journey Management Platform&trade; (JMP)</p>
          <p>
            Here’s the HMG-owned technology that brings it all together. This flexible platform connects 
            the phases of a consumer’s relationship with a brand and supports all types of direct-to-consumer 
            programs with integrated strategy, delivery, and analytics. We built JMP to offer our clients an 
            entirely modular approach to optimizing a consumer’s end-to-end experience with their brand &mdash; and 
            do so from a single, holistic platform.
          </p>
        </div>

        <div class="ui-g-12 ui-g-center">
          <hr class="break">
        </div>

        <div class="ui-g-3 ui-md-12 ui-sm-12 about-us-cont">
          <h2 class="title">Select Clients + Brand Partners</h2>
        </div>

        <div class="ui-g-9 ui-md-12 ui-sm-12 logo-cont">
          <img src="static/logos/gen@2x.png">
          <img src="static/logos/hu@2x.png">
          <img src="static/logos/infiniti-logomark@2x.png">
          <img src="static/logos/nis@2x.png">
          <img src="static/logos/ally-logo@2x.png">
          <img src="static/logos/bcbs-logo@2x.png">
          <img src="static/logos/bose-logo@2x.png">
          <img src="static/logos/allergan-logo@2x.png">
          <img src="static/logos/jaguar-logo@2x.png">
          <img src="static/logos/shinola-logo@2x.png">
          <img src="static/logos/life@2x.png">
          <img src="static/logos/nyfw@2x.png">
          <!-- <img src="static/logos/mazda-logo@2x.png">
          <img src="static/logos/lincoln-logo@2x.png">
          <img src="static/logos/allergan-logo@2x.png">
          <img src="static/logos/nest-logo@2x.png">
          <img src="static/logos/gopro-logo@2x.png"> -->
        </div>

        <div class="ui-g-12 ui-g-center">
          <hr class="break">
        </div>

        <div class="ui-g-3 ui-md-12 ui-sm-12 about-us-cont" id="contact">
          <h2 class="title">Contact HMG</h2>
        </div>

        <div class="ui-g-4 ui-md-6 ui-sm-12 about-us-cont">
          <h3 class="sub-heading adjusted-top-margins">Location</h3>
          <p class="ui-g-block street-address"
          >121 W Long Lake Road<br>
          Suite 120<br>
          Bloomfield Hills, MI 48304
          </p>  
        </div>

        <div class="ui-g-5 ui-md-6 ui-sm-12 about-us-cont contact">
          <h3 class="sub-heading adjusted-margins adjusted-top-margins">Contact</h3>
          <p class="phone">1 (248) 723-6300</p>
          <a href="mailto:info@harris-hmg.com" class="ui-g-block">info@harris-hmg.com</a>
          <a
            href="mailto:newbusiness@harris-hmg.com"
            class="ui-g-block adjusted-margins"
          >newbusiness@harris-hmg.com</a>
        </div>
      </div>

      <div class="ui-g-12 ui-g-center pg-top-link">
        <a href="#" v-scroll-to="'#top'">Back to Top</a>
      </div>

      <div class="ui-g-12 ui-g-center footer">
        <img src="static/hmg-logos/HMG-logomark_landing-page-footer@1x.svg" class="logo">
        <p>&copy; 2020 | Harris Marketing Group, Inc.</p>
        <a target="_blank" href="https://www.facebook.com/hmg.agency/" class="icons-cont">
          <i class="fab fa-facebook-f icons fb"></i>
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/explore/locations/451047751/harris-marketing-group/"
          class="icons-cont"
        >
          <i class="fab fa-instagram icons insta"></i>
        </a>
        <a
          target="_blank"
          href="https://www.linkedin.com/company/harris-marketing-group"
          class="icons-cont"
        >
          <i class="fab fa-linkedin-in icons in"></i>
        </a>
      </div>
    </div>
    <div>
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data: () => ({}),
  created() {
    //preload all hero images after 0.5 seconds
    setTimeout(() => {
      var images = new Array();
      function preload(sources) {
        for (var i = 0; i < sources.length; i++) {
          images[i] = new Image();
          images[i].src = sources[i];
        }
      }
      preload([
        "/static/images/exclusiviti/infiniti-usa_exclusiviti_1.jpg",
        "/static/images/qx50/infiniti-usa_2019-qx50_1.jpg",
        "/static/images/nissan/nissan-usa_2018-leaf_1.jpg",
        "/static/images/ally/ally-bank_surprise-delight-campaign_1.jpg",
        "/static/images/bcbs/bcbsm_healthy-blue-xtras_1.jpg",
        "/static/images/mazda-summer/mazda-canada_summer-sales-event_1.jpg",
        "/static/images/trender/tender_ongoing-fashion-campaign_1.jpg",
        "/static/images/mazda-winter/mazda-canada_winter-sales-event_1.jpg",
        "/static/images/nissan-usa-2019-altima/nissan-usa_2019-altima_1.jpg",
        "/static/images/mazda-canada-clubhouse-privileges/mazda-canada_clubhouse-privileges_1.jpg"
      ]);
    }, 500);
  },
  updated() {},
  methods: {
    loadRoute(route) {
      this.popupFlag = true;
      this.$router.push(route);
    }
  }
};
</script>
<style lang="scss" scoped>
.project-cont:hover {
  .words {
    opacity: 1;
  }

  .fade {
    opacity: 0.7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue